import React from 'react';
import main from '../../main';
interface Props {
  tips?: string;
}
export default function DefaultLoading({ tips }: Props) {
  return (
    <div className="text-center">
      <img className="w-200 h-140" src={main.pic('pic_loading.png')} alt="" />
      <div>{tips ?? '正在加载...'}</div>
    </div>
  );
}
